import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/category/new',
  title: 'Cadastrar Categoria',
  endpoint: '/app/store_product_category',
}
